/**
 * ***********************
 * Mail Sync Routes Components *
 * ***********************
 */
const MailSync = () => import('@/components/SystemAdmin/MailSync');
const MailSyncReport = () => import('@/components/SystemAdmin/MailSyncReport');

const mailSynchronisation = {
    title: 'Mail Synchronisation',
    link: '/configuration/mail-sync/p1',
    permission: [
        {
            action: 'request',
            entity: 'mailsync'
        }
    ],
    path: 'mail-sync/p:pageNumber?',
    component: MailSync,
    props: { pageType: 'ORG' },
    meta: {
        permission: [
            {
                action: 'request',
                entity: 'mailsync'
            }
        ],
    }
};

const mailSyncReport = {
    path: 'mail-sync/:mailSyncId',
    component: MailSyncReport,
    meta: { fromType: 'Mail Synchronisation' },
    props: { pageType: 'ORG' }
};

export {mailSynchronisation, mailSyncReport};